import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Error as ErrorIcon, Warning as WarningIcon } from '@material-ui/icons';
import UserForm from './UserForm';

function UserModal({
  open,
  isEditMode,
  formData,
  roles,
  onClose,
  onSubmit,
  onInputChange,
  loading = false,
  error = null,
}) {
  const { t } = useTranslation();
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleValidationChange = (hasErrors, errors) => {
    setHasValidationErrors(hasErrors);
    setValidationErrors(errors);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (hasValidationErrors) {
      console.warn('Formulario tiene errores:', validationErrors);
      return;
    }

    onSubmit(e);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isEditMode ? t('Edit user') : t('New user')}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {/*  Mostrar error del servidor si existe */}
          {error && (
            <Box
              mb={2}
              p={2}
              style={{
                backgroundColor: '#ffebee',
                border: '1px solid #f44336',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
              }}>
              <ErrorIcon style={{ color: '#f44336', marginRight: '8px' }} />
              <Typography variant="body2" style={{ color: '#c62828' }}>
                {error}
              </Typography>
            </Box>
          )}
          <UserForm
            formData={formData}
            roles={roles}
            isEditMode={isEditMode}
            onInputChange={onInputChange}
            onValidationChange={handleValidationChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" disabled={loading}>
            {t('CANCEL')}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={loading || hasValidationErrors}
            startIcon={loading ? <CircularProgress size={20} /> : null}>
            {loading ? t('SAVING...') : isEditMode ? t('UPDATE') : t('ADD')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default UserModal;
